import {
    Fragment,
    useContext,
    useRef,
    useState,
    useEffect,
    useMemo,
    useCallback,
} from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '#src/context/UserContext.js';
import { OrderContext } from '#src/context/OrderContext.js';
import { Dialog, Transition } from '@headlessui/react';
import { OrderUploadHandlerModal } from '../orderElements/files/orderUploadHandlerModal';
import { APICreateNewOrder, APISaveOrder} from '../../api/orders/Orders';
import {APICreateContract} from "../../api/orders/OrdersContracts";
import {APIPostOrderLinkedMessaging} from "../../api/orders/OrdersMessaging";
import {APICreateOrderTender} from "../../api/orders/OrdersTender";
import {APIGetCompanyAccess} from "../../api/companies/Companies";
import { settings } from '../../components/orderElements/settings/settings';
import { LuUsers } from "react-icons/lu";
import { SelectBox } from '../formFields/selectBox';
import { SelectList } from '../formFields/selectList';
import { InputText } from '../formFields/inputText';
import { Datepicker } from '../formFields/datePicker';
import { SelectInput } from '../formFields/selectInput';
import { CommunitySearch } from '../formFields/communitySearch';
import { TextArea } from '../formFields/textArea';
import { CommunicationPartner } from '../formFields/communicationPartner';
import { TfiClose } from "react-icons/tfi";
import { FaCheck } from "react-icons/fa6";

import {
    TbArrowsSplit,
    TbListDetails,
} from 'react-icons/tb';
import { VscListSelection } from 'react-icons/vsc';
import { MdOutlineFileUpload } from 'react-icons/md';


export const NewOrderModal = ({ openNewOrderModal, setOpenNewOrderModal, planId}) => {
    const { user } = useContext(UserContext);
    const { order, orderEdit, getOrder } = useContext(OrderContext);
    const cancelButtonRef = useRef(null);
    const [deadline, setDeadline] = useState({});
    const [orderType, setOrderType] = useState(null);
    const [community, setCommunity] = useState(null);
    const [planType, setPlanType] = useState([]);
    const [otherRequirements, setOtherRequirements] = useState([]);
    const [orderName, setOrderName] = useState('');
    const [plotArea, setPlotArea] = useState('');
    const [legalPlanStatus, setLegalPlanStatus] = useState('');
    const [depthOfCoverage, setDepthOfCoverage] = useState('');
    const [textualDeterminations, setTextualDeterminations] = useState('');
    const [procedure, setProcedure] = useState('');
    const [xplanV, setXplanV] = useState('');
    const [projection, setProjection] = useState('');
    const [additionalInformation, setAdditionalInformation] = useState('');
    const [currentPage, setCurrentPage] = useState(0);
    const [progress, setProgress] = useState(0);
    const [pageValid, setPageValid] = useState(false);
    const [orderId, setOrderId] = useState(crypto.randomUUID());
    const [communicationPartner, setCommunicationPartner] = useState([{
        name: '',
        department: '',
        phone: '',
        email: '',
    }]);
    const [partnerValid, setPartnerValid] = useState(false);
    const [tenderType, setTenderType] = useState('xplanung24');
    const [contractedCompany, setContractedCompany] = useState(null);
    const [planCreators, setPlanCreators] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [companyScope, setCompanyScope] = useState('');
      useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const companyAccess = await APIGetCompanyAccess(user.companyId);
        if (companyAccess === null || companyAccess.length === 0) {
          setCompanyScope(user.companyId);
        } else {
          const companiesArr = companyAccess.map((company) => {
            return {
              id: company.target_id,
              name: company.name,
            };
          });
          setCompanies(companiesArr);
          setCompanyScope('');
        }
      } catch (error) {
        console.error('Error:', error);
      }
    };
      
    fetchCompanies();
  }, [user.companyId]);

    const creators = useMemo(() => [
        {id: "4bc746b3-2a02-4cab-b342-13f12c843fe8", name: "Spacedatists"},
        {id: "f03c270c-aaa8-418b-b06d-0ef10ac4b84e", name: "geoGLIS"},
        {id: "a8a07a27-3e97-4c22-a692-3cd491a3cbb9", name: "BKI."},
        {id: "306adc01-56ec-4160-b1b3-80f17f2aa5ee", name: "RMK"},
       // {id: "a911b7ff-4509-431d-b5ed-e517d75c1640", name: "TS Company"},
    ], []);

    const navigate = useNavigate();

    useEffect(() => {
        const fetchCompanies = async () => {
          try {
            const companyAccess = await APIGetCompanyAccess(user.companyId);
            if (companyAccess === null || companyAccess.length === 0) {
              setCompanyScope(user.companyId);
            } else {
              const companiesArr = companyAccess.map((company) => {
                return {
                  id: company.target_id,
                  name: company.name,
                };
              });
              setCompanies(companiesArr);
              setCompanyScope('');
            }
          } catch (error) {
            console.error('Error:', error);
          }
        };
          
        fetchCompanies();
      }, [user.companyId]);

    const formPages = useMemo(
        () => [
            {
                jsx: (
                    <div className='flex h-full flex-col gap-2 lg:gap-4'>
                         {companies.length > 0 && companyScope === '' && (
                          <div className="bg-white mt-6">
                            <ul className="list-disc flex flex-col list-inside gap-2">
                                <SelectInput
                                    label={'Gemeinde'}
                                    id={'company'}
                                    requested={true}
                                    options={companies}
                                    value={companyScope}
                                    setValue={setCompanyScope}
                                />
                            </ul>
                          </div>
                        )}
                        {companyScope !== '' && (
                        <SelectBox
                            label={settings.orderTypes.label}
                            options={settings.orderTypes.options}
                            requested={settings.orderTypes.requested}
                            value={orderType}
                            setValue={setOrderType}
                        />
                        )}
                    </div>
                ),
                title: 'Art des Auftrags',
                info: 'Was soll beauftragt werden?',
                icon: <TbArrowsSplit className='h-5 w-5' />,
                values: [orderType],
                requested: [settings.orderTypes.requested],
            },
            {
                jsx: (
                    <div className='flex h-full flex-col text-sm gap-2 lg:gap-4'>
                        <SelectList
                            label={settings.planType.label}
                            options={settings.planType.options}
                            requested={settings.planType.requested}
                            value={planType}
                            setValue={setPlanType}
                        />
                         <TextArea
                            label={settings.additionalInformation.label}
                            id={settings.additionalInformation.id}
                            requested={settings.additionalInformation.requested}
                            unit={settings.additionalInformation.unit}
                            value={additionalInformation}
                            setValue={setAdditionalInformation}
                        />
                    </div>
                ),
                title: 'Angaben zum Auftrag',
                info: 'Details zum Auftragsumfang und der Art der Lieferung',
                icon: <VscListSelection className='h-5 w-5' />,
                values: [planType, additionalInformation],
                requested: [settings.planType.requested, settings.additionalInformation.requested],
            },
            {
                jsx: (
                    <div className='flex h-full flex-col gap-2 lg:gap-4'>
                        <InputText
                            label={settings.name.label}
                            id={settings.name.id}
                            requested={settings.name.requested}
                            unit={settings.name.unit}
                            value={orderName}
                            setValue={setOrderName}
                        />
                        <InputText
                            label={settings?.plotArea.label}
                            id={settings?.plotArea.id}
                            requested={settings?.plotArea.requested}
                            unit={settings?.plotArea.unit}
                            value={plotArea}
                            setValue={setPlotArea}
                        />
                        <SelectInput
                            label={settings?.legalPlanStatus.label}
                            id={settings?.legalPlanStatus.id}
                            requested={settings?.legalPlanStatus.requested}
                            options={settings?.legalPlanStatus.options}
                            value={legalPlanStatus}
                            setValue={setLegalPlanStatus}
                        />
                        <SelectInput
                            label={settings?.procedure.label}
                            id={settings?.procedure.id}
                            requested={settings?.procedure.requested}
                            options={settings?.procedure.options}
                            value={procedure}
                            setValue={setProcedure}
                        />
                        <SelectInput
                            label={settings?.depthOfCoverage.label}
                            id={settings?.depthOfCoverage.id}
                            requested={settings?.depthOfCoverage.requested}
                            options={settings?.depthOfCoverage.options}
                            value={depthOfCoverage}
                            setValue={setDepthOfCoverage}
                        />
                        <Datepicker
                            label={settings?.deadline.label}
                            id={settings?.deadline.id}
                            requested={settings?.deadline.requested}
                            unit={settings?.deadline.unit}
                            value={deadline}
                            setValue={setDeadline}
                        />

                        <SelectInput
                            label={settings?.textualDeterminations.label}
                            id={settings?.textualDeterminations.id}
                            requested={
                                settings?.textualDeterminations.requested
                            }
                            options={settings?.textualDeterminations.options}
                            value={textualDeterminations}
                            setValue={setTextualDeterminations}
                        />
                        <SelectInput
                            label={settings?.requestedXPlanVersion.label}
                            id={settings?.requestedXPlanVersion.id}
                            requested={
                                settings?.requestedXPlanVersion.requested
                            }
                            options={settings?.requestedXPlanVersion.options}
                            value={xplanV}
                            setValue={setXplanV}
                        />
                        <SelectInput
                            label={settings?.projection.label}
                            id={settings?.projection.id}
                            requested={settings?.projection.requested}
                            options={settings?.projection.options}
                            value={projection}
                            setValue={setProjection}
                        />
                    </div>
                ),
                title: 'Angaben zum Planwerk',
                info: 'Was soll im Planwerk dargestellt werden?',
                icon: <TbListDetails className='h-5 w-5' />,
                values: [
                    orderName,
                    plotArea,
                    legalPlanStatus,
                    procedure,
                    depthOfCoverage,
                    deadline,
                    textualDeterminations,
                    xplanV,
                    projection,
                ],
                requested: [settings.name.requested, settings.plotArea.requested, settings.legalPlanStatus.requested, settings.procedure.requested, settings.depthOfCoverage.requested, settings.deadline.requested, settings.textualDeterminations.requested, settings.requestedXPlanVersion.requested, settings.projection.requested],
            },
            {
                jsx: (
                    <div className='flex h-full flex-col gap-2 lg:gap-4'>
                        <div>
                            <CommunitySearch
                                community={community}
                                setCommunity={setCommunity}
                            />
                        </div>
                        <div className='flex h-full flex-col text-sm gap-2 lg:gap-4 overflow-y-auto'>
                            <CommunicationPartner communicationPartner={communicationPartner} setCommunicationPartner={setCommunicationPartner} setPartnerValid={setPartnerValid}/>
                        </div>
                    </div>
                ),
                title: 'Zuständige Gemeinde benennen',
                info: 'Wenn können wir bei Rückfragen kontaktieren?',
                icon: <LuUsers className='h-5 w-5' />,
                values: [community, communicationPartner],
                requested: [true, false],
            },
            {
                jsx: (
                    <div className='flex h-full  flex-col gap-2 lg:gap-4'>
                        <OrderUploadHandlerModal
                            companyId={user.companyId}
                            orderId={orderId}
                        />
                    </div>
                ),
                title: 'Bestandsunterlagen hochladen',
                info: 'Hinterlegen Sie alle Dokumente, welche für die Erstellung herangezogen werden können.',
                icon: <MdOutlineFileUpload className='h-5 w-5' />,
                values: [],
                requested: [false],
            },
            {
                jsx: (
                    <div className='flex h-full  flex-col'>
                        <h4 className={"text-xl font-bold"}>Auftragserfassung abschließen</h4>

                        <div className="px-4 mt-12 sm:gap-4 sm:px-0">
                             <div className=" text-sm  flex rounded-xl cursor-pointer justify-between text-center" >
                                 <span onClick={() => setTenderType("xplanung24")} className={(tenderType === "xplanung24") ? "bg-white  border-gray-900 border-2 py-3 border-b-0 -m-1 rounded-t-xl w-1/2 z-10": " text-gray-600/60  border-white border-2  py-2 w-1/2 rounded-xl" }>
                                    Kostenloses Angebot anfordern
                                 </span>
                                 <span onClick={() => setTenderType("directSelection")} className={(tenderType === "directSelection") ? "bg-white   border-gray-900 border-2 border-b-0 py-3 -m-1 rounded-t-xl w-1/2 z-10": "text-gray-600/60  border-white border-2 py-2 w-1/2 rounded-xl"}>
                                    Direkt Experten-Büro zuweisen
                                 </span>
                            </div>

                            {(tenderType === "xplanung24") && (
                                <div className={"border-gray-900 border-2 rounded-b-xl p-8 mt-[2px] -mx-[4px]"}>
                                    <p className={"text-sm  leading-6 text-gray-600/60  mb-8"}>Möchten Sie ein kostenloses Angebot für Ihren Auftrag erhalten? Wählen Sie einfach die Experten-Büros, von denen Sie ein Angebot anfordern möchten. Wir informieren Sie umgehend, sobald das Angebot für Sie bereitsteht.</p>

                                    <dl className="divide-y divide-gray-100 ">
                                        <div className=" sm:gap-4 sm:px-0">
                                            <SelectList
                                                label={""}
                                                size={'small'}
                                                options={creators}
                                                requested={false}
                                                value={planCreators}
                                                setValue={setPlanCreators}
                                                selectAll={true}
                                            />
                                        </div>
                                    </dl>
                                </div>
                            )}
                            {(tenderType === "directSelection") && (
                                <div className={"border-gray-900 border-2 rounded-b-xl p-8 mt-[2px] -mx-[4px]"}>
                                    <p className={"text-sm leading-6 text-gray-600/60  mb-8"}>Möchten Sie den Auftrag direkt einem Experten-Büro zuweisen? In diesem Fall wird der Auftrag sofort an das ausgewählte Partner-Büro übermittelt, und es erfolgt keine Angebotseinholung mehr.</p>

                                    <div
                                        className=" py-2 sm:gap-4 sm:px-0">
                                        <SelectBox
                                            label={""}
                                            options={creators}
                                            requested={false}
                                            value={contractedCompany}
                                            setValue={setContractedCompany}
                                        />
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                ),
                title: 'Auftrag abschließen',
                info: 'Schließen Sie Ihren Auftrag ab und fordern Sie ein kostenloses Angebot an.',
                icon: <FaCheck  className='h-5 w-5' />,
                values: [],
                requested: [false],
            },

        ],
        [companies, companyScope, orderType, planType, additionalInformation, orderName, plotArea, legalPlanStatus, procedure, depthOfCoverage, deadline, textualDeterminations, xplanV, projection, community, communicationPartner, user.companyId, orderId, tenderType, creators, planCreators, contractedCompany]
    );

    const saveNewOrder = async (orderState) => {
        const communicationPartnerArray = [];
        communicationPartner.forEach((partner) => {
            if (partner.name !== '') {
                communicationPartnerArray.push(partner);
            }
        });
        
        const newOrder = {
            id: orderId,
            createdByCompany: user.companyId,
            createdByUser: user.id,
            updatedByUser: user.id,
            type: 'XPlan',
            planDetails: {
                orderTypes: orderType,
                planType: planType ? planType.map((t) => {
                    const type = {}
                    type[t] = true
                    return type
                }) : [],
                name: orderName,
                deadline: deadline,
                plotArea: plotArea,
                legalPlanStatus: legalPlanStatus,
                depthOfCoverage: depthOfCoverage,
                textualDeterminations: textualDeterminations,
                procedure: procedure,
                requestedXPlanVersion: xplanV,
                projection: projection,
                additionalInformation: additionalInformation,
                otherRequirements: otherRequirements ? otherRequirements.map((r) => {
                    const req = {}
                    req[r] = true
                    return req
                }) : [],
                community: community,
                communicationPartner: communicationPartnerArray,    
            },
        };

        const newOrderObject = await APICreateNewOrder(newOrder, user, planId ? `${user.companyId}/plans/${planId}/master.gml` : null);

        if (orderState !== "draft") {
            if ( tenderType === "xplanung24" && planCreators.length > 0) {
                const bidData = {
                    bidProcess: tenderType,
                    planCreators: planCreators,
                }
                
                await APICreateOrderTender(orderId, bidData?.bidProcess, bidData, user)
                await APISaveOrder({order: {...newOrderObject, stage: "inTender"}, companyId: user.companyId})
            } else if (tenderType === "directSelection" && contractedCompany) {
                const bidData = {
                    bidProcess: tenderType,
                    contractedCompany: contractedCompany,
                }
                let companyName = ""
                for(const a of creators) {
                    if(bidData?.contractedCompany === a.id) {
                        companyName = a.name
                    }
                }

                const messageData = {
                    ordersId : orderId,
                    linkId : orderId,
                    linkType : "progressUpdate",
                    createdByUser : user?.id,
                    createdByUserName : user?.name,
                    createdByCompany : user?.companyId,
                    createdByCompanyName : user?.companyId,
                    message : "Auftrag direkt vergeben an: "+companyName +" durch Auftraggeber",
                    orderCompany: user?.companyId,
                    contractedCompany: contractedCompany,
                    planId: newOrderObject?.planId,
                }
                
                // create Contract
                
                const tender = await APICreateOrderTender(orderId, bidData?.bidProcess, bidData, user)
                APICreateContract(orderId, tender?.id , null, bidData?.contractedCompany, user, "directSelection");
                APIPostOrderLinkedMessaging({messageData, companyId: user.companyId})
                await APISaveOrder({order: {...newOrderObject, stage: "contracted"}, companyId: user.companyId})
            }
        }

        if (newOrderObject) {
            navigate(`/order/${orderId}`);
            setOpenNewOrderModal(false);
            return true;
        }
        return false;
    };

    const updateOrder = async (orderState) => {
        const updatedOrder = {
            ...order,
            planDetails: {
                orderTypes: orderType,
                planType: planType ? planType.map((t) => { 
                    const type = {}
                    type[t] = true
                    return type
                }) : [],
                name: orderName,
                deadline: deadline,
                plotArea: plotArea,
                legalPlanStatus: legalPlanStatus,
                depthOfCoverage: depthOfCoverage,
                textualDeterminations: textualDeterminations,
                procedure: procedure,
                requestedXPlanVersion: xplanV,
                projection: projection,
                additionalInformation: additionalInformation,
                otherRequirements: otherRequirements ? otherRequirements.map((r) => { 
                    const req = {}
                    req[r] = true
                    return req
                }) : [],
                community: community,
            },
        };

        const updatedOrderObject = await APISaveOrder({order: updatedOrder, companyId: user.companyId});

        if (orderState !== "draft") {
            if ( tenderType === "xplanung24" && planCreators.length > 0) {
                const bidData = {
                    bidProcess: tenderType,
                    planCreators: planCreators,
                }
                
                await APICreateOrderTender(orderId, bidData?.bidProcess, bidData, user)
                await APISaveOrder({order: {...updatedOrderObject, stage: "inTender"}, companyId: user.companyId})
            } else if (tenderType === "directSelection" && contractedCompany) {
                const bidData = {
                    bidProcess: tenderType,
                    contractedCompany: contractedCompany,
                }
                let companyName = ""
                for(const a of creators) {
                    if(bidData?.contractedCompany === a.id) {
                        companyName = a.name
                    }
                }

                const messageData = {
                    ordersId : orderId,
                    linkId : orderId,
                    linkType : "progressUpdate",
                    createdByUser : user?.id,
                    createdByUserName : user?.name,
                    createdByCompany : user?.companyId,
                    createdByCompanyName : user?.companyId,
                    message : "Auftrag direkt vergeben an: "+companyName +" durch Auftraggeber",
                    orderCompany: user?.companyId,
                    contractedCompany: contractedCompany,
                    planId: updatedOrderObject?.planId,
                }
                
                // create Contract
                
                const tender = await APICreateOrderTender(orderId, bidData?.bidProcess, bidData, user)
                APICreateContract(orderId, tender?.id , null, bidData?.contractedCompany, user, "directSelection");
                APIPostOrderLinkedMessaging({messageData, companyId: user.companyId})
                await APISaveOrder({order: {...updatedOrderObject, stage: "contracted"}, companyId: user.companyId})
            }
        }

        if (updatedOrderObject) {
            await getOrder();
            setOpenNewOrderModal(false);
            return true;
        }
        return false;
    }

    const handleSaveOrder = async (orderState = "") => {
        if (orderEdit) {
            return updateOrder(orderState);
        } else {
            return saveNewOrder(orderState);
        }
    };

    const getProgressLarge = (index) => {
        const isDone = index < currentPage;
        const isCurrent = index === currentPage;
        return (
            <div
                key={index}
                className={`${
                    isDone || isCurrent
                        ? '  bg-indigo-900 text-gray-900'
                        : ' border border-gray-300 bg-gray-900 text-white'
                } relative z-10 grid w-8 h-8 font-bold  transition-all duration-300 rounded-full place-items-center`}>
                <div
                    className={`${
                        isDone || isCurrent ? ' text-gray-900' : 'text-white'
                    } p-1`}>
                    {formPages[index].icon}
                </div>
                <div className='absolute left-[3.5rem] w-[200px]'>
                    <h6
                        className={`${
                            isDone || isCurrent
                                ? 'text-indigo-900'
                                : 'text-gray-300/70'
                        } block font-sans text-base antialiased text-sm font-semibold leading-relaxed tracking-normal`}>
                        {formPages[index].title}
                    </h6>
                    <p
                        className={`${
                            isDone || isCurrent
                                ? 'text-white'
                                : 'text-gray-500/70'
                        } block font-sans text-base antialiased text-xs font-normal leading-relaxed`}>
                        {formPages[index].info}
                    </p>
                </div>
            </div>
        );
    };

    useEffect(() => {
        setProgress((currentPage * 100) / (formPages.length - 1));
    }, [currentPage, formPages]);


    useEffect(() => {
        const checKValidation = () => {
            const page = formPages[currentPage];
            const values = page.values;
            const requested = page.requested;
            const validation = values.map((value, index) => {
                if (requested[index] === true) {
                    if (value === '' || value === null || value === undefined || value.length === 0) {
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    return true;
                }
            });
            const valid = validation.every((value) => value === true);
            setPageValid(valid);
        };

        checKValidation();
    }, [
        currentPage,
        formPages,
        orderType,
        community,
        deadline,
        plotArea,
        orderName,
        legalPlanStatus,
        depthOfCoverage,
        textualDeterminations,
        procedure,
        xplanV,
        projection,
        otherRequirements,
        additionalInformation,
        partnerValid,
        tenderType
    ]);

    useEffect(() => {
        if (!openNewOrderModal || !order || !orderEdit) return;

        setOrderId(order.id);
        if (order.planDetails) {
            setDeadline(order.planDetails.deadline);
            setOrderType(order.planDetails.orderTypes);
            setCommunity(order.planDetails.community);
            setPlanType(order.planDetails.planType.map((t) => Object.keys(t)[0]));
            setOtherRequirements(order.planDetails.otherRequirements.map((t) => Object.keys(t)[0]));
            setOrderName(order.planDetails.name);
            setPlotArea(order.planDetails.plotArea);
            setLegalPlanStatus(order.planDetails.legalPlanStatus);
            setDepthOfCoverage(order.planDetails.depthOfCoverage);
            setTextualDeterminations(order.planDetails.textualDeterminations);
            setProcedure(order.planDetails.procedure);
            setXplanV(order.planDetails.requestedXPlanVersion);
            setProjection(order.planDetails.projection);
            setAdditionalInformation(order.planDetails.additionalInformation);
        }
    }, [order, openNewOrderModal, orderEdit]);

    return (
        <Transition.Root show={openNewOrderModal} as={Fragment}>
            <Dialog
                className='relative z-10'
                initialFocus={cancelButtonRef}
                onClose={() => {
                    setOpenNewOrderModal(false)
                    if (companies.length > 0) {
                        setCompanyScope('');
                  }}}>
                <Transition.Child
                    as={Fragment}
                    enter='ease-out duration-300'
                    enterFrom='opacity-0'
                    enterTo='opacity-100'
                    leave='ease-in duration-200'
                    leaveFrom='opacity-100'
                    leaveTo='opacity-0'>
                    <div className='fixed inset-0 w-screen h-dvh bg-gray-500 bg-opacity-75 transition-opacity' />
                </Transition.Child>

                <div className='fixed inset-0 z-10'>
                    <div className='flex h-full items-center justify-center sm:px-4 sm:pb-4 text-center pt-[65px] sm:px-4 lg:p-10 max-w-5xl mx-auto'>
                        <Transition.Child
                            as={Fragment}
                            enter='ease-out duration-300'
                            enterFrom='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
                            enterTo='opacity-100 translate-y-0 sm:scale-100'
                            leave='ease-in duration-200'
                            leaveFrom='opacity-100 translate-y-0 sm:scale-100'
                            leaveTo='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'>
                            <Dialog.Panel className='flex flex-col max-h-full sm:max-h-max h-full md:h-auto rounded-lg bg-white text-left shadow-xl transition-all w-full relative'>
                                <button
                                    type='button'
                                    className='absolute z-40 lg: lg:-top-6 lg:-right-6 top-2 right-2'
                                    onClick={() => {
                                        setOpenNewOrderModal(false);
                                    }}
                                    ref={cancelButtonRef}>
                                    <TfiClose className={"lg:size-16 border-gray-500/80 border-2 bg-white hover:bg-gray-300 lg:p-4 size-12 p-2 lg:rounded-full rounded-md"}/>
                                </button>


                                <div className='flex w-full h-full'>
                                    <div className='hidden rounded-tl-lg rounded-bl-lg py-8 px-8 md:flex w-2/5 bg-gray-900 flex-col'>
                                        <div>
                                            <div className='flex items-center m-4 mb-8 gap-2'>
                                                <Dialog.Title
                                                    as='h3'
                                                    className='font-bold text-2xl leading-6 text-white'>
                                                    {orderEdit ? 'Auftrag bearbeiten' : 'Neuen Auftrag erfassen'}
                                                </Dialog.Title> 
                                            </div>
                                        </div>



                                        <div className={'h-[750px]'}>
                                            <div className='h-full w-full p-4 pb-8'>
                                                <div className='relative flex flex-col items-start pl-[0px] justify-between h-full'>
                                                    <div className='absolute top-0 left-[15px] border border-gray-500 border-dashed h-full -translate-x-2/4 bg-gray-400'></div>
                                                    <div className={`absolute top-0 left-[15px] w-0.5 bg-indigo-900 -translate-x-2/4  transition-all duration-500`} style={{height: `${progress}%`, }}></div>
                                                    {formPages.map((_, index) =>
                                                        getProgressLarge(index)
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'md:w-3/5 p-4 pb-0 flex flex-col w-full lg:max-h-[calc(100vh-65px)]'}>
                                        <div className='p-8 flex flex-col flex-1 overflow-y-auto'>
                                            <div className='flex md:hidden bg-gray-200 rounded-full h-2 mb-4 dark:bg-gray-700'>
                                                <div
                                                    className='bg-gray-600 h-2 rounded-full'
                                                    style={{
                                                        width: `${progress}%`,
                                                    }}></div>
                                            </div>
                                            <div className='w-full'>
                                                {formPages[currentPage].jsx}
                                            </div>
                                        </div>
                                        <div
                                            className={
                                                'p-8 sm:flex-row-reverse flex w-full flex-col-reverse gap-4'
                                            }>
                                            {progress === 100 ? (
                                                <div className='flex justify-between gap-2 w-full'>
                                                    <button
                                                        type='button'
                                                        className='disabled:opacity-25 items-center rounded-md bg-white border-2  border-gray-500 text-gray-600/60 px-3 py-2 text-sm font-semibold w-24'
                                                        onClick={() => {
                                                            if (
                                                                currentPage > 0
                                                            ) {
                                                                setCurrentPage(
                                                                    currentPage -
                                                                        1
                                                                );
                                                            }
                                                        }}>
                                                        Zurück
                                                    </button>


                                                    <button
                                                        type='button'
                                                        className='disabled:opacity-25 items-center rounded-md bg-white border-2 ml-10 border-gray-900 text-gray-900 px-3 py-2 text-sm font-semibold w-48'
                                                        onClick={() => { setTenderType(""); setContractedCompany(null); handleSaveOrder('draft')}}
                                                    >
                                                        {'Entwurf speichern'}
                                                    </button>
                                                    <button
                                                        type='button'
                                                        className='disabled:opacity-25 rounded-md bg-indigo-900   border-2 py-2 px-3 border-indigo-900  text-sm text-white font-semibold w-48'
                                                        onClick={() => {handleSaveOrder()}}
                                                        disabled={!pageValid || (tenderType === "xplanung24" && planCreators.length === 0) || (tenderType === "directSelection" && !contractedCompany)}
                                                    >
                                                        { tenderType === "xplanung24" ? 'Angebote einholen' : 'Direkt beauftragen'}
                                                    </button>
                                                </div>
                                            ) : (
                                                <div className='flex justify-between gap-8 w-full'>
                                                    <button
                                                        type='button'
                                                        className={`${
                                                            currentPage === 0
                                                                ? 'invisible'
                                                                : 'visible'
                                                        } disabled:opacity-25 items-center rounded-md bg-white border-2 py-2 px-4 border-gray-500 text-gray-600 px-3 py-2 text-sm font-semibold  w-24`}
                                                        onClick={() => {
                                                            if (
                                                                currentPage > 0
                                                            ) {
                                                                setCurrentPage(
                                                                    currentPage -
                                                                        1
                                                                );
                                                            }
                                                        }}>
                                                        Zurück
                                                    </button>
                                                    <button
                                                        type='button'
                                                        disabled={!pageValid || (!partnerValid && currentPage === 5)}
                                                        title={(!pageValid || (!partnerValid && currentPage === 5)) && "Bitte Pflichtfelder füllen!"}
                                                        className='disabled:opacity-25 inline-flex justify-center rounded-md bg-gray-900 px-3 py-2 text-sm font-semibold text-white  w-24'
                                                        onClick={() => {
                                                            if (
                                                                currentPage <
                                                                formPages.length -
                                                                    1
                                                            ) {
                                                                setCurrentPage(
                                                                    currentPage +
                                                                        1
                                                                );
                                                            }
                                                        }}>
                                                        Weiter
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
};
